function USAMobileNumber(value: string) {
  return /^\(\d{3}\) \d{3}-\d{4}$/.test(value);
}

function email(value: string) {
  return /^[\w+.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value);
  // return /^[a-z0-9+.]+@[a-z0-9]+\.[a-z]+$/.test(value);
}

function date(value: string) {
  return /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12]\d|3[01])\/((19|[2-9][0-9])\d{2})/.test(
    value
  );
}

function time(value: string) {
  return /^(?:2[0-3]|[01]?\d):[0-5]\d:[0-5]\d$/.test(value);
}

function positiveNumber(value: string) {
  return /^\d*([.]?\d+)$/.test(value);
}

function address(value: string) {
  return !!value?.length;
}

export const UtilityValidator = {
  USAMobileNumber,
  email,
  date,
  time,
  positiveNumber,
  address,
};
